/**
 * SVG Timescale icon
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
};

export function UnstyledTimescaleDBIcon({ ...props }) {
  const { classes, ...additionalProps } = props;
  return (
    <SvgIcon viewBox="0 0 120 120" {...additionalProps}>
      <g>
        <circle className={classes.st0} cx="60" cy="60" r="55.5" />
        <g>
          <circle className={classes.st1} cx="60.2" cy="66.1" r="24.7" />
          <g>
            <circle className={classes.st1} cx="60.2" cy="46.3" r="1.7" />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M71.5,49.8c-0.5,0.8-1.5,1.1-2.3,0.6s-1.1-1.5-0.6-2.3s1.5-1.1,2.3-0.6C71.7,48,72,49,71.5,49.8z"
            />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M78.1,57.6c-0.8,0.5-1.8,0.2-2.3-0.6s-0.2-1.8,0.6-2.3c0.8-0.5,1.8-0.2,2.3,0.6
              C79.2,56.2,78.9,57.2,78.1,57.6z"
            />
          </g>
          <g>
            <circle className={classes.st1} cx="80" cy="66.1" r="1.7" />
          </g>
          <g>
            <ellipse className={classes.st2} cx="77.3" cy="75.9" rx="1.7" ry="1.7" />
          </g>
          <g>
            <ellipse className={classes.st3} cx="70.1" cy="83.2" rx="1.7" ry="1.7" />
          </g>
          <g>
            <ellipse className={classes.st4} cx="60.2" cy="85.8" rx="1.7" ry="1.7" />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M48.9,82.3c0.5-0.8,1.5-1.1,2.3-0.6s1.1,1.5,0.6,2.3s-1.5,1.1-2.3,0.6C48.8,84.2,48.5,83.1,48.9,82.3z"
            />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M42.3,74.5c0.8-0.5,1.8-0.2,2.3,0.6c0.5,0.8,0.2,1.8-0.6,2.3s-1.8,0.2-2.3-0.6C41.2,76,41.5,75,42.3,74.5z"
            />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M40.5,64.4c0.9,0,1.7,0.7,1.7,1.7c0,0.9-0.7,1.7-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7
              C38.8,65.2,39.6,64.4,40.5,64.4z"
            />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M43.9,54.8c0.8,0.5,1.1,1.5,0.6,2.3s-1.5,1.1-2.3,0.6s-1.1-1.5-0.6-2.3C42.1,54.6,43.1,54.3,43.9,54.8z"
            />
          </g>
          <g>
            <circle className={classes.st1} cx="50.3" cy="49" r="1.7" />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M61.8,46.3c0,0.9-0.7,1.7-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7
              C61.1,44.7,61.8,45.4,61.8,46.3z"
            />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M60.2,93.9c-15.3,0-27.8-12.5-27.8-27.8s12.5-27.8,27.8-27.8S88,50.7,88,66.1S75.6,93.9,60.2,93.9z
              M60.2,41.6c-13.5,0-24.4,11-24.4,24.4c0,13.5,11,24.4,24.4,24.4c13.5,0,24.4-11,24.4-24.4C84.7,52.6,73.7,41.6,60.2,41.6z"
            />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M40,98.2c-0.3,0-0.7-0.1-0.9-0.3c-0.8-0.5-1-1.6-0.4-2.3l3.2-4.7c0.5-0.8,1.6-1,2.3-0.4
              c0.8,0.5,1,1.6,0.4,2.3l-3.2,4.7C41,97.9,40.5,98.2,40,98.2z"
            />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M75.2,46.3c-0.3,0-0.7-0.1-0.9-0.3c-0.8-0.5-1-1.6-0.4-2.3l1.2-1.8c0.5-0.8,1.6-1,2.3-0.4
              c0.8,0.5,1,1.6,0.4,2.3l-1.2,1.8C76.3,46.1,75.8,46.3,75.2,46.3z"
            />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M84.3,32.9c-0.3,0-0.7-0.1-0.9-0.3c-0.8-0.5-1-1.6-0.4-2.3l1.6-2.3c0.5-0.8,1.6-1,2.3-0.4
              c0.8,0.5,1,1.6,0.4,2.3l-1.6,2.3C85.4,32.7,84.9,32.9,84.3,32.9z"
            />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M87.6,49.6L87.6,49.6c-0.6,0-1.1-0.3-1.4-0.7c-2.2-3.3-4.9-6.1-8.1-8.3c-3.1-2.2-6.5-3.7-10.2-4.6
              c-0.5-0.1-1-0.5-1.2-1.1c-0.2-0.5-0.1-1.1,0.2-1.6c2.5-3.5,6.6-5.6,11-5.6c7.4,0,13.5,6.1,13.5,13.5c0,2.8-0.8,5.4-2.4,7.7
              C88.6,49.3,88.1,49.6,87.6,49.6z M71.4,33.4c3,1,5.9,2.5,8.6,4.4c2.8,2,5.3,4.3,7.4,7c0.4-1.1,0.7-2.3,0.7-3.6
              C88,35.5,83.5,31,77.9,31C75.5,31,73.2,31.9,71.4,33.4z"
            />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M80,98.2c-0.5,0-1.1-0.3-1.4-0.7l-3.2-4.7c-0.5-0.8-0.3-1.8,0.4-2.3c0.8-0.5,1.8-0.3,2.3,0.4l3.2,4.7
              c0.5,0.8,0.3,1.8-0.4,2.3C80.7,98.1,80.3,98.2,80,98.2z"
            />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M44.8,46.3c-0.5,0-1.1-0.3-1.4-0.7l-1.2-1.8c-0.5-0.8-0.3-1.8,0.4-2.3c0.8-0.5,1.8-0.3,2.3,0.4l1.2,1.8
              c0.5,0.8,0.3,1.8-0.4,2.3C45.4,46.3,45.1,46.3,44.8,46.3z"
            />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M35.7,32.9c-0.5,0-1.1-0.3-1.4-0.7l-1.6-2.3c-0.5-0.8-0.3-1.8,0.4-2.3c0.8-0.5,1.8-0.3,2.3,0.4l1.6,2.3
              c0.5,0.8,0.3,1.8-0.4,2.3C36.3,32.8,36,32.9,35.7,32.9z"
            />
          </g>
          <g>
            <path
              className={classes.st1}
              d="M32.4,49.6c-0.5,0-1.1-0.3-1.4-0.7c-1.6-2.3-2.4-4.9-2.4-7.7c0-7.4,6.1-13.5,13.5-13.5c4.3,0,8.4,2.1,11,5.6
              c0.3,0.5,0.4,1,0.2,1.6c-0.2,0.5-0.6,0.9-1.2,1.1c-3.6,0.9-7.1,2.5-10.2,4.6c-3.2,2.3-6,5.1-8.1,8.3C33.5,49.3,33,49.6,32.4,49.6
              L32.4,49.6z M42.1,31C36.5,31,32,35.5,32,41.1c0,1.2,0.2,2.5,0.7,3.6c2.1-2.7,4.6-5,7.4-7c2.7-1.9,5.5-3.3,8.6-4.4
              C46.8,31.9,44.5,31,42.1,31z"
            />
          </g>
        </g>
        <g>
          <path
            className={classes.st5}
            d="M60.6,70.5c-0.5,0-1-0.2-1.3-0.6L48.7,56.7c-0.6-0.7-0.5-1.8,0.3-2.4c0.7-0.6,1.8-0.5,2.4,0.3L61,66.5
            l6.6-4.8c0.7-0.5,1.8-0.4,2.4,0.4c0.5,0.7,0.4,1.8-0.4,2.4l-7.9,5.7C61.3,70.4,61,70.5,60.6,70.5z"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

UnstyledTimescaleDBIcon.propTypes = propTypes;

const styles = (theme) => ({
  circleStyle: {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: theme.customColors.teal,
    stroke: theme.customColors.teal,
  },
  searchStyle: {
    fill: theme.customColors.white,
    stroke: theme.customColors.teal,
  },
  st0: {
    fill: theme.customColors.white,
    stroke: theme.customColors.teal,
    strokeWidth: 7,
  },
  st1: {
    fill: theme.customColors.teal,
    stroke: theme.customColors.teal,
    strokeWidth: 0.1309,
    strokeMiterlimit: 10,
  },
  st2: {
    fill: theme.customColors.teal,
    stroke: theme.customColors.teal,
    strokeWidth: 0.1309,
    strokeMiterlimit: 10.0002,
  },
  st3: {
    fill: theme.customColors.teal,
    stroke: theme.customColors.teal,
    strokeWidth: 0.1309,
    strokeMiterlimit: 9.9997,
  },
  st4: {
    fill: theme.customColors.teal,
    stroke: theme.customColors.teal,
    strokeWidth: 0.1309,
    strokeMiterlimit: 10.0001,
  },
  st5: { fill: theme.customColors.white },
});

export default withStyles(styles)(UnstyledTimescaleDBIcon);
